import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EOtpremniceClient, NacinOtpreme } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-nacin-otpreme-dropdown',
  templateUrl: './nacin-otpreme-dropdown.component.html',
  styleUrls: ['./nacin-otpreme-dropdown.component.scss']
})
export class NacinOtpremeDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';
  @Output() onItemChange = new EventEmitter<NacinOtpreme>();

  constructor(
    private _client : EOtpremniceClient,
  ) { }

  ngOnInit(): void {
    this._load();
  }

  private async _load() {
    this._subs.add(
      this._client.getNacinOtpreme().subscribe((res) => {
        this.items = res.data!.nacinOtpremeDtoList!.map((x) => ({
          value: x.nacinOtpreme,
          label: x.nacinOtpremeStr,
          title: x.opis,
        }));
        this.items.unshift({ value: null, label: 'Izaberite način otpreme' });
      })
    );
  }

  handleOnItemChange(event: any) {
    this.onItemChange.emit(event.value);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
